import React, { Component } from "react"
import { connect } from "react-redux"
import styles from "./styles.css"
import Card from "../../../components/Card"
import _ from "lodash"
import * as strings from "../../../strings"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"

class BillingOrderDetails extends Component {
  props: {
    clients: [],
    value: any,
    onChange: any,
  }

  handleChange = name => async value => {
    const newBillingOrder = {
      ...this.props.value,
      [ name ]: value,
    }

    this.props.onChange( newBillingOrder )
  }

  render () {
    const billingPhaseSource = _.entries( strings.BillingPhaseTranslation )
      .map( ( [ value, key ] ) => ( { label: key, value } ) )

    const debtPhaseSource = _.entries( strings.DebtPhaseTranslation )
      .map( ( [ value, key ] ) => ( { label: key, value } ) )

    const clientSource = _.chain( this.props.clients )
      .map( ( { name } ) => ( { value: name, label: name } ) )
      .orderBy( "label" )
      .value()

    return (
      <Card>
        <div className={styles.mainRow}>
          <Dropdown
            label={strings.generalStrings.billingPhase}
            source={billingPhaseSource}
            auto={false}
            value={this.props.value.billingPhase}
            onChange={this.handleChange( "billingPhase" )}
          />
          <Dropdown
            label={strings.processes.processPhase}
            source={debtPhaseSource}
            auto={false}
            value={this.props.value.debtPhase}
            onChange={this.handleChange( "debtPhase" )}
          />
          <Dropdown
            label={strings.generalStrings.company}
            source={clientSource}
            auto={false}
            value={this.props.value.clientName}
            onChange={this.handleChange( "clientName" )}
          />
          <Dropdown
            label={strings.generalStrings.segment}
            source={[ {
              value: null,
              label: "Sem segmento",
            }, {
              value: "B2B",
              label: "B2B",
            }, {
              value: "B2C",
              label: "B2C",
            } ]}
            value={this.props.value.segment}
            onChange={this.handleChange( "segment" )}
          />
        </div>
      </Card>
    )
  }
}

export default connect( ( store ) => ( {
  clients: _.get( store, "suggestions.clients", [] ),
} ) )( BillingOrderDetails )



// WEBPACK FOOTER //
// ./src/views/CreateBillingOrder/Details/index.jsx